export default __webpack_public_path__ + "static/img-art-pandas-profiling-11-42e230790db244e95d9c1ad1b68afd3f.webp";